import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cb3ea0a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "error"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "error__inner"
};
const _hoisted_4 = {
  class: "error-wrapper"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "error-title"
}, [/*#__PURE__*/_createTextVNode("Что-то пошло не так."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Ваш заказ отменен")], -1));
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    class: "error-img",
    src: require('@/img/icon/cancel.svg'),
    alt: "error"
  }, null, 8, _hoisted_5), _hoisted_6, _createElementVNode("button", {
    class: "error-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.repeatOrder && $options.repeatOrder(...args))
  }, [_createElementVNode("img", {
    src: require('@/img/icon/order.svg'),
    alt: ""
  }, null, 8, _hoisted_7), _createTextVNode("Оформить повторно")])])])])]);
}